var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "sc-27769c74-4 iLIPAj",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9998 32C63.9998 49.6733 49.673 64 31.9998 64C14.3265 64 -0.000244141 49.6733 -0.000244141 32C-0.000244141 14.3267 14.3265 0 31.9998 0C49.673 0 63.9998 14.3267 63.9998 32Z",
    fill: "#FFD032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6518 23.5356C16.1168 23.5356 14.2167 24.1515 13.0996 25.4548C11.9395 26.8106 11.9921 28.8873 11.9921 29.9328V39.7624H15.5725V35.1937H21.8599V39.7624H25.4356V29.9662C25.4356 28.3096 25.3783 26.5862 24.2851 25.4309C23.1011 24.1754 21.2058 23.5404 18.647 23.5404L18.6518 23.5356ZM21.8647 31.661H15.5773V29.4602C15.5773 27.7224 16.5273 26.8488 18.6518 26.8488C20.9099 26.8488 21.8647 27.8036 21.8647 29.4602V31.6657V31.661ZM52.0076 23.6025V27.2116C51.64 27.1591 51.2008 27.1257 50.6947 27.1257C48.5751 27.1257 47.6155 27.1448 47.6155 29.0782V39.7624H44.0303L44.0398 30.8828C44.0398 28.2523 44.0732 26.6531 45.1474 25.4596C46.2979 24.1849 48.1645 23.5404 50.6995 23.5404C51.1626 23.5404 51.5922 23.5691 52.0123 23.6073L52.0076 23.6025ZM37.8814 24.2374H41.4618V34.0623C41.4618 35.1125 41.5144 37.1845 40.3495 38.5403C39.2372 39.8436 37.3371 40.4642 34.8021 40.4642C32.2672 40.4642 30.348 39.8292 29.1641 38.5737C28.0804 37.4184 28.0088 35.695 28.0088 34.0336V24.2374H31.5893V34.5397C31.5893 36.1915 32.5488 37.151 34.8021 37.151C36.9218 37.151 37.8814 36.2774 37.8814 34.5397V24.2374Z",
    fill: "#FFFDFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAur);
export default __webpack_public_path__ + "static/media/aur.69440973b00dd380df22c89520de9df6.svg";
export { ForwardRef as ReactComponent };